import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import Axios from "../axios";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";

const SliceAndDice = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [packages, setPackages] = useState();
  const [city, setCity] = useState();
  const [allTrip, setAllTrip] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");

  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  const [totals, setTotals] = useState({
    totalGrossBookings: 0,
    totalNetBookings: 0,
  });
  //header for the CSv file
  const headers = [
    { label: "Chain Name", key: "hotelName" },
    { label: "Gross bookings", key: "allBookingsCount" },
    { label: "Net bookings", key: "confirmedBookingsCount" },
    { label: "Cancelled bookings", key: "failedBookingsCount" },
    { label: "Gross Revenue", key: "totalRateBookings" },
    { label: "Net Revenue", key: "totalRateConfirmedBookings" },
    { label: "Cancelled Revenue", key: "totalRateFailedBookings" },
    { label: "Gross Room nights", key: "totalRoomCount" },
    { label: "Net Room nights", key: "totalConfirmedRoomCount" },
    { label: "Cancelled Room nights", key: "totalFailedRoomCount" },
  ];

  useEffect(() => {
    fetchAllTrip(1, "", "");
    handleDownloadProcess();
  }, []);

  const fetchAllTrip = (page, search, id) => {
    let data = {
      page: page,
      searchChar: search,
      userID: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-chain-sales", data)
      .then((resp) => {
        setAllTrip(resp?.data?.data);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-chain-sales")
      .then((resp) => {
        const fetchedData = resp?.data?.data || [];
        // Calculate Totals
        const totalGrossBookings = fetchedData.reduce(
          (sum, item) => sum + (item.allBookingsCount || 0),
          0
        );
        const totalNetBookings = fetchedData.reduce(
          (sum, item) => sum + (item.confirmedBookingsCount || 0),
          0
        );
        const totalCancelledBookings = fetchedData.reduce(
          (sum, item) => sum + (item.failedBookingsCount || 0),
          0
        );

        const totalGrossRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateBookings || 0),
          0
        );
        const totalNetRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateConfirmedBookings || 0),
          0
        );
        const totalCancelRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateFailedBookings || 0),
          0
        );
        const totalGrossRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalRoomCount || 0),
          0
        );
        const totalNetRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalConfirmedRoomCount || 0),
          0
        );
        const totalCancelledRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalFailedRoomCount || 0),
          0
        );

        setTotals({
          totalGrossBookings,
          totalNetBookings,
          totalCancelledBookings,
          totalGrossRevenue,
          totalNetRevenue,
          totalCancelRevenue,
          totalGrossRoomNights,
          totalNetRoomNights,
          totalCancelledRoomNights,
        });

        // Add totals row to the CSV data
        const dataWithTotals = [
          ...fetchedData,
          {
            hotelName: "Total",
            allBookingsCount: totalGrossBookings,
            confirmedBookingsCount: totalNetBookings,
            failedBookingsCount: totalCancelledBookings,
            totalRateBookings: totalGrossRevenue,
            totalRateConfirmedBookings: totalNetRevenue,
            totalRateFailedBookings: totalCancelRevenue,
            totalRoomCount: totalGrossRoomNights,
            totalConfirmedRoomCount: totalNetRoomNights,
            totalFailedRoomCount: totalCancelledRoomNights, // Leave other fields blank or calculate if needed
          },
        ];

        setDownloadData(dataWithTotals);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Error fetching supplier data."
        );
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllTrip(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllTrip(1, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"chain.csv"}
            >
              <DownloadIcon className="downLoadCSVIcon" />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const columns = [
    {
      name: "hotelName",
      label: "Chain Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "allBookingsCount",
      label: "Gross bookings",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "confirmedBookingsCount",
      label: "Net bookings",

      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "failedBookingsCount",
      label: "Cancelled bookings",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "totalRateBookings",
      label: "Gross Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(allTrip[dataIndex]?.totalRateBookings).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },
    {
      name: "totalRateConfirmedBookings",
      label: "Net Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(
                  allTrip[dataIndex]?.totalRateConfirmedBookings
                ).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },
    {
      name: "totalRateFailedBookings",
      label: "Cancelled Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(
                  allTrip[dataIndex]?.totalRateFailedBookings
                ).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },

    {
      name: "totalRoomCount",
      label: "Gross Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: "totalConfirmedRoomCount",
      label: "Net Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "totalFailedRoomCount",
      label: "Cancelled Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];
  // Function for dialog open close

  const handleClose = () => {
    setOpen(false);
    setName("");
    setEmail("");
    setPackages("");
    setCity("");
  };

  return (
    <>
      <MUIDataTable
        title={"Chain List"}
        data={allTrip}
        columns={columns}
        options={options}
      />

      {/* ------------------------------Create Trip Section ---------------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3> Trip Details</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            className="my-2"
            placeholder="Enter your Full Name"
            name="name"
            value={name}
          />

          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            className="my-2"
            type="email"
            placeholder="abb@abbindia.com"
            name="email"
            value={email}
          />
          <TextField
            label="Package"
            variant="outlined"
            fullWidth
            className="my-2"
            name="packages"
            value={packages}
          />

          <TextField
            label="City"
            variant="outlined"
            fullWidth
            className="my-2"
            value={city}
            name="city"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default SliceAndDice;
